import { themeTokens } from "@diligentcorp/atlas-design-tokens";
import { getAtlasPresets } from "./getAtlasPresets.js";
import { getAtlasThemeOptions } from "./getAtlasThemeOptions.js";
export const atlasThemeOptions = getAtlasThemeOptions(themeTokens);
export const presets = getAtlasPresets(themeTokens);
//# sourceMappingURL=index.js.map